var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook11(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "73px",
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 178,
    transform: "translate(-210.000000, -37.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(210.076000, 37.405000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.863,71.726 L35.863,71.726 C16.056,71.726 -1.42108547e-14,55.67 -1.42108547e-14,35.863 C-1.42108547e-14,16.056 16.056,0 35.863,0 C55.67,0 71.726,16.056 71.726,35.863 C71.726,55.67 55.67,71.726 35.863,71.726",
    id: "Fill-30",
    fill: "#2B5A8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.399,57.541 L39.129,57.541 L39.129,35.679 L45.219,35.679 L45.869,28.359 L39.129,28.359 C39.129,28.359 39.129,25.626 39.129,24.19 C39.129,22.465 39.475,21.782 41.144,21.782 C42.487,21.782 45.869,21.782 45.869,21.782 L45.869,14.186 C45.869,14.186 40.888,14.186 39.824,14.186 C33.328,14.186 30.399,17.047 30.399,22.523 C30.399,27.293 30.399,28.359 30.399,28.359 L25.857,28.359 L25.857,35.77 L30.399,35.77 L30.399,57.541",
    id: "Fill-31",
    fill: "#FFFFFE"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook11);
export default __webpack_public_path__ + "static/media/facebook11.c4bb34779f54ee13f4772059e1bb7d0b.svg";
export { ForwardRef as ReactComponent };